import { Injectable } from '@angular/core';
import {ModalService} from './modal.service';
import {ModalImageGalleryComponent} from '../../core/modal-image-gallery/modal-image-gallery.component';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  /**
   * Constructor
   *
   * @param modal
   */
  constructor(private modal: ModalService) { }

  /**
   * Open a image in a modal
   *
   * @param url
   * @param title
   * @param gallery
   */
  openImage(url: string, title: string = '', gallery: object|null = null)
  {

    this.modal.Modal(ModalImageGalleryComponent, title, '', {url: url, gallery: gallery}, [], {size: 'xl'}).then( (result) => {

    });

  }
}
